import { Nickname_Schema } from "@/services/user/profile/profileSchema";
import { Rating_Schema } from "@/services/user/rating/ratingSchema";
import { WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";
import { UserId_Schema } from "./userIdSchema";

export const AvatarUrl_Schema = z.url().nullable();

export const UserStanding_Schema = z.object({
  score: WholeNumber_Schema,
  rank: WholeNumber_Schema,
});

export const UserPublicInfo_Schema = z
  .object({
    id: UserId_Schema,
    nickname: Nickname_Schema,
    avatarUrl: AvatarUrl_Schema,
    rating: Rating_Schema,
    ratingCount: WholeNumber_Schema,
    itemsCount: WholeNumber_Schema.optional(),
    userStanding: UserStanding_Schema,
  })
  .transform(({ userStanding, ...rest }) => ({
    ...rest,
    standing: userStanding ?? null,
  }));
